/* eslint-disable */

import EdnField from './ednField'
import EdnCat from './ednCat'
import EdnMemo from './ednMemo'
import EdnNum from './ednNum'
import EdnBtn from './ednBtn'
import EdnDate from './ednDate'
import EdnMail from './ednMail'
import EdnPhone from './ednPhone'
import EdnCheck from './ednCheck'
import EdnSwitch from './ednSwitch'
import EdnRadio from './ednRadio'
import EdnTime from './ednTime'
import EdnColor from './ednColor'
import EdnLoad from './ednLoad'
import EdnUrl from './ednUrl'
import EdnCopyPaste from './ednCopyPaste'
import EdnListMod from './ednListMod'
import EdnDateTime from './ednDateTime'
import EdnFile from './ednFile'
import EdnPopOver from './ednPopOver'
import EdnGoto from './ednGoto'
import EdnMimic from './ednMimic'
import EdnTooltip from './ednTooltip'
import SkeletonField from './skeletonField'
import EdnSkeletonTemplate from './ednSkeletonTemplate'
import EdnImage from './ednImage'
import EdnDialog from './ednDialog'
import EdnModal from './ednModal'
import EdnCatArbo from './ednCatArbo'
import EdnCatalogue from './ednCatalogue'
import EdnLogic from './ednLogic'
import EdnAlertSnackbar from './ednAlertSnackbar'
import EdnAlert from './ednAlert'
import EdnCalendar from './ednCalendar'
import EdnPreviewModal from './ednPreviewModal'
import EdnDateTimeInput from './ednDateTimeInput'
import EdnDateTimePicker from './ednDateTimePicker'

require('./assets/styles.scss')
require('./assets/img/default.jpg')

console.info('eudo-front version ' + require('./package.json').version)

// edn beta
import EdnMailBeta from './lab/ednMail'

const eudoFront = {
  install(Vue) {
    Vue.prototype.version = require('./package.json').version

    //import de templates de couleurs
    // Vue.prototype.themes = require('./themes/themes').eFrontThemes

    Vue.component('edn-field', EdnField)
    Vue.component('edn-cat', EdnCat)
    Vue.component('edn-memo', EdnMemo)
    Vue.component('edn-num', EdnNum)
    Vue.component('edn-btn', EdnBtn)
    Vue.component('edn-date', EdnDate)
    Vue.component('edn-mail', EdnMail)
    Vue.component('edn-phone', EdnPhone)
    Vue.component('edn-check', EdnCheck)
    Vue.component('edn-switch', EdnSwitch)
    Vue.component('edn-radio', EdnRadio)
    Vue.component('edn-time', EdnTime)
    Vue.component('edn-color', EdnColor)
    Vue.component('edn-load', EdnLoad)
    Vue.component('edn-url', EdnUrl)
    Vue.component('edn-copy-paste', EdnCopyPaste)
    Vue.component('edn-list-mod', EdnListMod)
    Vue.component('edn-date-time', EdnDateTime)
    Vue.component('edn-file', EdnFile)
    Vue.component('edn-pop-over', EdnPopOver)
    Vue.component('edn-goto', EdnGoto)
    Vue.component('edn-mimic', EdnMimic)
    Vue.component('edn-tooltip', EdnTooltip)
    Vue.component('skeleton-field', SkeletonField)
    Vue.component('edn-skeleton-template', EdnSkeletonTemplate)
    Vue.component('edn-image', EdnImage)
    Vue.component('edn-dialog', EdnDialog)
    Vue.component('edn-modal', EdnModal)
    Vue.component('edn-cat-arbo', EdnCatArbo)
    Vue.component('edn-catalogue', EdnCatalogue)
    Vue.component('edn-logic', EdnLogic)
    Vue.component('edn-snackbar', EdnAlertSnackbar)
    Vue.component('edn-alert', EdnAlert)
    Vue.component('edn-calendar', EdnCalendar)
    Vue.component('edn-preview-modal', EdnPreviewModal)
    Vue.component('edn-date-time-input', EdnDateTimeInput)
    Vue.component('edn-date-time-picker', EdnDateTimePicker)
    // edn beta
    Vue.component('edn-mail-beta', EdnMailBeta)
  },
}

export {
  EdnField,
  EdnCat,
  EdnMemo,
  EdnNum,
  EdnBtn,
  EdnDate,
  EdnMail,
  EdnPhone,
  EdnCheck,
  EdnSwitch,
  EdnRadio,
  EdnTime,
  EdnColor,
  EdnLoad,
  EdnUrl,
  EdnCopyPaste,
  EdnListMod,
  EdnDateTime,
  EdnFile,
  EdnPopOver,
  EdnGoto,
  EdnMimic,
  EdnTooltip,
  SkeletonField,
  EdnSkeletonTemplate,
  EdnImage,
  EdnDialog,
  EdnModal,
  EdnCatArbo,
  EdnCatalogue,
  EdnAlertSnackbar,
  EdnCalendar,
  EdnPreviewModal,
  EdnDateTimePicker
}

export default eudoFront
